
import React, { Fragment } from 'react'

const MonthRptListView = ({ onMahasulReport }: any) => {
    console.log(onMahasulReport)
    return (
        <Fragment>
            <Fragment>
                <div className='bg-white dark:bg-slate800 shodow rounded-md p-2'>
                    <div className="relative w-full overflow-x-auto overflow-y-auto h-[80vh]">
                        <table className="w-full text-sm whitespace-nowrap text-left rtl:text-right text-slate700 dark:text-slate400">
                            <thead className="text-[11px] top-0 sticky z-10 font-public-sans text-slate800 capitalize border-b dark:text-slate100 dark:border-slate700">
                                <tr>
                                    <th rowSpan={2} scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700 w-10">
                                        S.N.
                                    </th>
                                    <th rowSpan={2} scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Member Name
                                    </th>
                                    <th rowSpan={2} scope="col" className="px-2 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Address
                                    </th>
                                    <th rowSpan={2} scope="col" className="px-2 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Phone No
                                    </th>
                                    <th rowSpan={2} scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Marga/Tole
                                    </th>
                                    <th rowSpan={2} scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Reader Date
                                    </th>
                                    <th rowSpan={2} scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Reader Name
                                    </th>
                                    <th rowSpan={2} scope="col" className="px-2 dark:bg-slate-700 w-10 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Year/Month
                                    </th>
                                    <th align='center' colSpan={3} scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Meter Reading
                                    </th>
                                    <th align='center' rowSpan={2} scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Consume Amount
                                    </th>
                                </tr>
                                <tr>
                                    <th align='center' scope="col" className="px-2 dark:bg-slate-700 w-10 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Prev Unit
                                    </th>
                                    <th align='center' scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Current Unit
                                    </th>
                                    <th align='center' scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                                        Consume Unit
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Array.isArray(onMahasulReport?.results) && onMahasulReport?.results?.length > 0 ? (onMahasulReport?.results?.map((item: any, index: number) => (
                                        <tr key={index} className="bg-white hover:bg-slate100 hover:cursor-pointer text-[11px] font-public-sans dark:bg-slate800 text-slate800 dark:hover:bg-slate600">
                                            <td align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {index + 1}.
                                            </td>
                                            <td className="px-2 py-0.5 capitalize sticky left-0 bg-white border border-slate300 dark:border-slate700 italic">
                                                {`${item?.mem_name ? item?.mem_name : ""}`}
                                            </td>
                                            <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.add_eng}
                                            </td>
                                            <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.phone_no}
                                            </td>
                                            <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.tole_name}
                                            </td>
                                            <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.date_n}
                                            </td>
                                            <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.reader_name}
                                            </td>
                                            <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.yearr}/{item?.monthh}
                                            </td>
                                            <td align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {parseFloat(item?.unit_total || 0) - parseFloat(item?.consume_unit || 0)}
                                            </td>
                                            <td align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.unit_total}
                                            </td>
                                            <td align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.consume_unit}
                                            </td>
                                             <td align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                                {item?.consume_amt}
                                            </td>
                                        </tr>
                                    ))) : <tr className="bg-white text-[12px] font-public-sans dark:bg-slate800 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <td align='center' colSpan={16} className="px-2 py-1 border dark:border-gray-700">
                                            <span>No Payroll Found</span>
                                        </td>
                                    </tr>

                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </Fragment>
        </Fragment>
    )
}

export default MonthRptListView